export default "/images/f96b0ec43a2a2001ad53253e5310aaff.avif";